import { render, staticRenderFns } from "./ProductFamily.vue?vue&type=template&id=c53afa3c"
import script from "./ProductFamily.vue?vue&type=script&lang=ts"
export * from "./ProductFamily.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports